// extracted by mini-css-extract-plugin
export var aside = "news-single-content-module--aside--mzbnZ";
export var data = "news-single-content-module--data--YY5M+";
export var innerWrapper = "news-single-content-module--inner-wrapper--Logrb";
export var mainContent = "news-single-content-module--main-content--WXcj4";
export var mainTitle = "news-single-content-module--main-title--CArVq";
export var newsArticleSection = "news-single-content-module--news-article-section--lZ+kr";
export var newsContainer = "news-single-content-module--news-container--YWYZM";
export var newsletter = "news-single-content-module--newsletter--i0iFb";
export var panel = "news-single-content-module--panel--z7Zrf";
export var previousNewsContainer = "news-single-content-module--previous-news-container--G0r5Q";